import React, { FunctionComponent, SyntheticEvent } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { DialogProps } from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import styles from './styles';
import JetCrossDefault from '@assets/JETCross-content-default.svg';
import JetButton from '../JetButton';
import JetDialog from '../JetDialog';
import { useMediaQuery } from '@material-ui/core';

interface TPopupProps extends DialogProps {
  activePopup: any;
  onConfirm: any;
  onClose: any;
  cySlug: string;
  isWizardMode?: boolean;
  children?: any;
  showDescription?: boolean;
  disableEscapeKeyDown?:boolean;
  disableBackdropClick?:boolean;
  isPlural?: boolean;
}

const Popup: FunctionComponent<TPopupProps> = ({
  open,
  activePopup,
  onConfirm,
  onClose,
  fullScreen,
  isWizardMode = false,
  showDescription = true,
  cySlug,
  children,
  disableEscapeKeyDown = false,
  disableBackdropClick = false,
  isPlural = false
}) => {
  const classes = styles();
  const { t } = useTranslation();
  const isMobileScreen = useMediaQuery('(min-width:1024px)');
  const buttonSize = isMobileScreen ? 'medium' : 'small';
  const handleClose = (event: any,reason: string) => {
    if(disableBackdropClick && reason === 'backdropClick') {
      return false;
    }
    if(disableEscapeKeyDown && reason === 'escapeKeyDown') {
      return false;
    }
    if(typeof onClose === 'function') {
      onClose()
    }
  }
  return (
    <JetDialog
      open={open}
      onClose={handleClose}
      fullScreen={false}
      classes={{
        paper: classes.paper,
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      data-cy={cySlug}
      disableScrollLock={true}
    >
      <IconButton
        onClick={onClose}
        classes={{ root: classes.closeButton }}
        aria-label="close"
      >
        <img
          src={JetCrossDefault}
          className={classes.closeButtonIcon}
          alt="Close"
        />
      </IconButton>
      <Typography variant="h4" className={`heading_m ${classes.title}`}>
        {t(`popup.${activePopup.type}_title`, {
          courierName: activePopup.variables?.courierName || '',
          orderId: activePopup.variables?.orderId || '',
          count: isPlural ? 2: 1
        })}
      </Typography>
      <div className={classes.alertDialogDescription}>
        {children}
        {showDescription ? (
          <Typography
            id="alert-dialog-description"
            variant="body1"
            className="body_regular alert-dialog-description"
            align="left"
          >
            <Trans>
              {t(`popup.${activePopup.type}_description`, {
                courierEmail: activePopup.courierEmail,
                courierName: activePopup.variables?.courierName || '',
                orderId: activePopup.variables?.orderId || '',
                count: isPlural ? 2: 1
              })}
            </Trans>
          </Typography>
        ) : null}
      </div>
      <div className={classes.buttonsContainer}>
        <JetButton
          shoulddisplayprogress={activePopup?.isPending.toString()}
          size={buttonSize}
          variation="primary"
          onClick={() => {
            onConfirm({
              courierId: activePopup.courierId,
              courierEmail: activePopup.courierEmail,
              courierHash: activePopup.courierHash,
              hash: activePopup.hash,
              variables: activePopup.variables,
            });
          }}
          autoFocus
          type="submit"
        >
          {t(`popup.${activePopup.type}_confirm`, {
            courierName: activePopup.variables?.courierName || '',
          })}
        </JetButton>
        {isWizardMode ? null : (
          <JetButton
            className={classes.actionButtonCancel}
            variation="ghost"
            onClick={onClose}
            size={buttonSize}
          >
            {t(`popup.${activePopup.type}_cancel`, {
              courierEmail: activePopup.courierEmail,
            })}
          </JetButton>
        )}
      </div>
    </JetDialog>
  );
};

export default Popup;
